<template>
     <el-popover
        placement="bottom-end"
        width="300"
        trigger="click"
        v-model="popShow"
    >
        <el-button 
            slot="reference" 
            size="small" 
            plain
        >
            <i class="el-icon-tickets"></i>
            Exportar Relatório
        </el-button>

        <div>
            <h5 class="font-weight-bold mb-3">Relatórios</h5>

            <el-divider class="mt-3"></el-divider>

            <el-form 
                :model="filters" 
                ref="distributorExport" 
                label-position="top" 
                status-icon 
            >
                <!-- File types -->
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <div 
                        class="rounded d-flex justify-content-center align-items-center position-relative"
                        :style="{ 
                            width: '64px', 
                            height: '64px',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: '#c2e7b0',
                            backgroundColor: '#f0f9eb'
                        }"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#67C23A" class="bi bi-filetype-xls" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"/>
                        </svg>
                        
                    </div>
                    <h5 class="font-weight-bolder text-center mt-2">XLS</h5>
                </div>

                <el-row :gutter="20">
                    <el-col>
                        <el-form-item 
                            prop="periodo"
                            :rules="[{ required: true, message: 'O período é obrigatório', trigger: 'change' }]"
                            class="mb-0"
                        >
                            <label>Período</label>
                            <el-date-picker
                                unlink-panels
                                size="small"
                                v-model="filters.periodo"    
                                type="daterange"
                                start-placeholder="Inicio"
                                end-placeholder="Fim"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col v-if="isAbleToExport" class="mt-3">
                        <div class="d-flex justify-content-center">
                            <span v-if="data.length == 1"><b>{{ data.length }} Transação encontrada.</b></span>
                            <span v-else><b>{{ data.length }} Transações encontradas.</b></span>
                        </div>
                    </el-col>
    
                    <el-col class="mt-4">
                       <div class="d-flex justify-content-end">
                            <el-button
                                type="danger"
                                plain
                                size="large"
                                circle
                                :disabled="!isAbleToExport"
                                @click.native="handleClearExport"
                            >
                                <i class="el-icon-delete"></i>   
                            </el-button>
                            
                            <export-excel
                                :key="exportKey"
                                :class="[
                                    'el-button el-button--large rounded-pill',
                                    !isAbleToExport ? 'is-plain el-button--default': 'el-button--success',
                                ]"
                                :style="{ width: '100%' }"
                                :data="data"
                                :fields="headerExcel"
                                :before-generate="exportReport"
                                worksheet="Distribuidores"
                                :name="generateNameFile"
                            >   
                                <i v-if="isLoading" class="el-icon-loading"></i>
                                <i v-else class="el-icon-tickets"></i>

                                <span v-if="isAbleToExport">Exportar relátorio</span>
                                <span v-else>Preparar relátorio</span>
                            </export-excel>
                       </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </el-popover>
</template>
<script>
    // Components
    import {
        Card,
        Button,
        Row,
        Col,
        Form,
        FormItem,
        Select,
        Option,
        RadioGroup,
        RadioButton,
        Notification,
        Tag,
        Avatar,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Empty,
        Popover,
        Divider,
        Badge
    } from 'element-ui'

    //Api
    import { VendedorApi } from "@/api/VendedorApi";
    const vendedorApi = new VendedorApi();

    // Utils
    import { formatDate } from '@/util/formatters';

    // Api
    import { DistribuidorIndicadoApi } from '@/api/DistribuidorIndicadoApi.js';
    const distribuidorIndicadoApi = new DistribuidorIndicadoApi()

    export default {
        data() {
            return {
                popShow: false,
                isLoading: false,
                isAbleToExport: false,
                exportKey: 0, // ⬅ usado para forçar remontagem do export-excel
                filters: {
                    periodo: null,
                    status: null,
                    consultant_user_id: null,
                    type_report: null
                },
                data: [],
                headerExcel: {
                    "Distribuidor": "nome",
                    "Email": "email",
                    "Telefone": "telefone",
                    "Cidade": "cidade",
                    "Estado": "estado",
                    "Status": "status",
                    "Analisado por": "user.name",
                    "Criado em": {
                        field: 'created_at',
                        callback: (value) => {
                            return formatDate(value)
                        }
                    },
                }
            }
        },
        methods: {
            async fetch() {
                
            },
            /**
             * Obtem os vendedores
             */
            async exportReport() {
                this.$refs.distributorExport.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading
                    const elLoading = this.$loading({ customClass: 'loader-indicative-bottom-right' })

                    try {

                        const res = await distribuidorIndicadoApi.index({
                            periodo: this.filters.periodo,
                            should_be_excel: true,
                        });

                        this.data = res;

                        this.isAbleToExport = true;
                    } catch (err) {
                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível exportar o relatório!'
                        });
                    } finally {
                        elLoading.close();
                        this.isLoading = false;
                    }
                });
            },
            /**
             * Limpa os campos do formulário, os resultados obtidos
             * e reseta o componente de exportação para o estado inicial.
             */
            handleClearExport() {
                this.filters.periodo = null;
                this.data = [];
                this.isAbleToExport = false;
                this.isLoading = false;

                // a) limpar o estado visual de validação
                // b) remontar o export-excel
                 this.$nextTick(() => {
                    this.$refs.distributorExport.clearValidate();
                    this.exportKey++;
                });
            },
            formatDate
        },  
        computed: {
            generateNameFile() {
                const date = new Date();

                const formatted =
                    String(date.getDate()).padStart(2, '0') + '-' +
                    String(date.getMonth() + 1).padStart(2, '0') + '-' +
                    date.getFullYear();

                return `distribuidores-${formatted}`
            },  
        },
        watch: {
            "popShow"(_newValue) {
                if(_newValue == false) {
                    this.handleClearExport();
                }
            },
        },
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Select.name]: Select,
            [Option.name]: Option,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Notification.name]: Notification,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Empty.name]: Empty,
            [Popover.name]: Popover,
            [Divider.name]: Divider,
            [Badge.name]: Badge
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/indicados/distribuidores_indicados/Export.vue